import { TableColumnsType } from "antd";
import { useCallback, useMemo } from "react";
import { ConstatGravity } from "../../../../types/constatGravities";
import DropdownOptionsConstatGravities from "../components/DropdownOptionsConstatGravities/DropdownOptionsConstatGravities";

type Options = {
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

export default function useTableConstatGravities({ onModify, onDelete }: Options) {
  const columns = useMemo(() => {
    const _columns: TableColumnsType<ConstatGravity> = [
      {
        title: "CODE",
        dataIndex: "code",
        key: "code",
        align: "left",
        width: 120,
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "NOM",
        dataIndex: "name",
        key: "name",
        align: "left",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "DESCRIPTION",
        dataIndex: "description",
        key: "description",
        align: "left",
        sorter: true,
        sortDirections: ["ascend", "descend"],
      },
      {
        title: "",
        dataIndex: "",
        align: "center",
        key: "actions",
        width: 10,
        render: (_, item) => (
          <DropdownOptionsConstatGravities
            itemId={item.id}
            onModify={onModify}
            onDelete={onDelete}
          />
        ),
      },
    ];
    return _columns;
  }, [onModify, onDelete]);

  const onRowClick = useCallback(
    (record: ConstatGravity) => ({ onClick: () => onModify(record.id) }),
    [onModify],
  );

  return { columns, onRowClick };
}
